import { render, staticRenderFns } from "./myBenefits.vue?vue&type=template&id=31694901&scoped=true"
import script from "./myBenefits.vue?vue&type=script&lang=js"
export * from "./myBenefits.vue?vue&type=script&lang=js"
import style0 from "./myBenefits.vue?vue&type=style&index=0&id=31694901&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31694901",
  null
  
)

export default component.exports